function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "._7DdHg,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.uIFh5{color:var(--ricos-custom-hashtag-color,var(--ricos-action-color,#0261ff));font-family:var(--ricos-custom-hashtag-font-family,unset);font-size:var(--ricos-custom-hashtag-font-size,unset);font-style:var(--ricos-custom-hashtag-font-style,unset);font-weight:var(--ricos-custom-hashtag-font-weight,unset);line-height:var(--ricos-custom-hashtag-line-height,unset);min-height:var(--ricos-custom-hashtag-min-height,unset);text-decoration:var(--ricos-custom-hashtag-text-decoration,none)}.uIFh5:hover{text-decoration:underline}@supports not (contain:inline-size){@media only screen and (max-width:640px){.uIFh5{font-size:var(--ricos-custom-hashtag-font-size,unset)}}}@container (width < 640px){.uIFh5{font-size:var(--ricos-custom-hashtag-font-size,unset)}}";
var styles = {"fontElementMap":"_7DdHg","hashtag":"uIFh5"};
styleInject(css_248z);

export { styles as s };
//# sourceMappingURL=hashtag-0d2a412a.js.map
